import React, { FC } from 'react';
import MuiStepLabel, { StepLabelProps as MuiStepLabelProps } from '@mui/material/StepLabel';
import { BpDesignSystem } from '../../types';
import { Typography } from '../Typography';
import { styled } from '../../styles';
import { mergeClassNames } from '../../utils';

export type StepLabelProps = BpDesignSystem.PropsWithChildren<
  MuiStepLabelProps & {
    error?: boolean;
  }
>;

/**
 * For vertical orientation use StepVerticalLabel
 * @param dataTest
 * @param rest
 * @constructor
 */
export const StepLabel: FC<StepLabelProps> = ({ dataTest, error, className, ...rest }) => (
  <MuiStepLabel
    data-test={dataTest}
    className={mergeClassNames(className, {
      'MuiStep-error': error
    })}
    {...rest}
  />
);

export const StepLabelVertical: FC<StepLabelProps & { subtitle?: React.ReactNode }> = ({
  dataTest,
  subtitle,
  children,
  error,
  className,
  ...rest
}) => (
  <MuiStepLabel
    color="primary"
    data-test={dataTest}
    className={mergeClassNames(className, {
      'MuiStep-error': error
    })}
    {...rest}
  >
    {!!subtitle && <StyledTypographyBody>{subtitle}</StyledTypographyBody>}
    <Typography.Title>{children}</Typography.Title>
  </MuiStepLabel>
);

const StyledTypographyBody = styled(Typography.Body)`
    color: ${({ theme }) => theme.tokens.colorOnSurfaceVariant}
`;
